import * as React from "react";
import { connect } from "react-redux";

import District from "../../screens/Settings/District";
import {
  fetchState,
  addDistrict,
  fetchDistrict,
  deleteDistrict,
  districtSearch,
  locSlectedPage,
  editDistrict,
  districtFilter
} from "./action";
class DistrictContainer extends React.Component<Props, State> {
  render() {
    return (
      <District
        fetchState={this.props.fetchState}
        stateList={this.props.stateList}
        addDistrict={this.props.addDistrict}
        fetchDistrict={this.props.fetchDistrict}
        DistrictList={this.props.DistrictList}
        deleteDistrict={this.props.deleteDistrict}
        districtDtlsCount={this.props.districtDtlsCount}
        districtSearch={this.props.districtSearch}
        DistrictListSearch={this.props.DistrictListSearch}
        locSlectedPage={this.props.locSlectedPage}
        DistrictSearchCount={this.props.DistrictSearchCount}
        editDistrict={this.props.editDistrict}
        districtFilter={this.props.districtFilter}
        FilterDistrictList={this.props.FilterDistrictList}
        FilterDistrictCount={this.props.FilterDistrictCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchState: () => {
      dispatch(fetchState());
    },
    addDistrict: (value) => {
      dispatch(addDistrict(value));
    },
    fetchDistrict: () => {
      dispatch(fetchDistrict());
    },
    deleteDistrict: (value) => {
      dispatch(deleteDistrict(value));
    },
    districtSearch: (value) => {
    
      dispatch(districtSearch(value));
    },
    locSlectedPage: (value) => {
      
      dispatch(locSlectedPage(value));
    },
    editDistrict: (value) => {
     
      dispatch(editDistrict(value));
    },
    districtFilter: (value) => {
    
      dispatch(districtFilter(value));
    },
  };
}
function mapStateToProps(state) {
  return {
    stateList: state.DistrictReducer.stateList,
    DistrictList: state.DistrictReducer.DistrictList,
    districtDtlsCount: state.DistrictReducer.districtDtlsCount,
    DistrictListSearch: state.DistrictReducer.DistrictListSearch,
    DistrictSearchCount: state.DistrictReducer.DistrictSearchCount,
    FilterDistrictList: state.DistrictReducer.FilterDistrictList,
    FilterDistrictCount: state.DistrictReducer.FilterDistrictCount,
  };
}

export default connect(mapStateToProps, bindAction)(DistrictContainer);
